// language=GraphQL
export const ALL_IMAGE_GALLERIES_QUERY = `query Query($withImages: Boolean = false) {
  imageGalleries: imageGalleries {
    id
    images @include(if: $withImages) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
  }
}`

// language=GraphQL
export const SINGLE_IMAGE_GALLERY_QUERY = `query Query($id: ID!, $withImages: Boolean = false) {
  imageGallery: imageGallery(id: $id) {
    id
    images @include(if: $withImages) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
  }
}`

// language=GraphQL
export const CREATE_IMAGE_GALLERY_MUTATION = `
  mutation Mutation($input: CreateImageGalleryInput, $withImages: Boolean = false) {
    imageGallery: createImageGallery(input: $input) {
      id
      images @include(if: $withImages) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }`

// language=GraphQL
export const UPDATE_IMAGE_GALLERY_MUTATION = `
  mutation Mutation($input: UpdateImageGalleryInput, $withImages: Boolean = false) {
    imageGallery: updateImageGallery(input: $input) {
      id
      images @include(if: $withImages) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }`

// language=GraphQL
export const DELETE_IMAGE_GALLERY_MUTATION = `
  mutation Mutation($input: DeleteImageGalleryInput) {
    deleteImageGallery(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_IMAGE_GALLERY_MUTATION = `
  mutation Mutation($input: DeleteImageGalleryInput) {
    forceDeleteImageGallery(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_IMAGE_GALLERY_IMAGES_MUTATION = `
  mutation Mutation($input: addImageGalleryImagesInput) {
    addImageGalleryImages(input: $input) {
      id
      imageIds
    }
  }`

// language=GraphQL
export const REMOVE_IMAGE_GALLERY_IMAGES_MUTATION = `
  mutation Mutation($input: removeImageGalleryImagesInput) {
    removeImageGalleryImages(input: $input) {
      id
      imageIds
    }
  }`

// language=GraphQL
export const CREATE_IMAGE_GALLERY_IMAGES_MUTATION = `
  mutation Mutation($input: createImageGalleryImagesInput) {
    createImageGalleryImages(input: $input) {
      id
      imageIds
    }
  }`

// language=GraphQL
export const DELETE_IMAGE_GALLERY_IMAGES_MUTATION = `
  mutation Mutation($input: deleteImageGalleryImagesInput) {
    deleteImageGalleryImages(input: $input) {
      id
      imageIds
    }
  }`

// language=GraphQL
export const UPDATE_IMAGE_GALLERY_IMAGES_ORDER_MUTATION = `
  mutation Mutation($input: updateImageGalleryImagesOrderInput) {
    updateImageGalleryImagesOrder(input: $input) {
      id
      imageIds
    }
  }`

// language=GraphQL
export const IMAGE_GALLERIES_DEPENDENTS_QUERY = `query Query($id: ID!, $withAccommodations: Boolean = false, $withTravels: Boolean = false, $withCmsTextWithImageBlocks: Boolean = false, $withCmsSliderBlocks: Boolean = false, $withAccommodationRoomTypes: Boolean = false) {
  groupedDependents: imageGalleryDependents(id: $id) {
    accommodations @include(if: $withAccommodations) {
      id
      label
      name
      stars
      description
    }
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      executionStatus
      title
      description
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      programType
      programText
      minPrice
      minPriceManualOverride
      currency    }
    cmsTextWithImageBlocks @include(if: $withCmsTextWithImageBlocks) {
      id
      title
      subtitle
      text
      imagePosition
      imageFixedAspectRatio
    }
    cmsSliderBlocks @include(if: $withCmsSliderBlocks) {
      id
      fluid
      size
      showDots
      showArrows
      showLightbox
      autoplay    }
    accommodationRoomTypes @include(if: $withAccommodationRoomTypes) {
      id
      name
      description
    }
  }
}`
